import './autoplay.css';

import { useViewModel } from '@descomplica/microfrontend-react';
import React, { useState } from 'react';

import { ClassroomViewModel } from '@/presentation/screens/classroom/classroom.vm';

import { Dot, SwitchContainer, SwitchInput, SwitchSlider, VerticalLine } from './styled';

export const Autoplay = () => {
  const vm = useViewModel(ClassroomViewModel);

  if (!vm.classroom) {
    return null;
  }

  const autoPlayLessonEnabled = vm.getAutoPlayLesson();

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [isChecked, setIsChecked] = useState(autoPlayLessonEnabled);
  const handleChange = (e) => {
    setIsChecked(e.target.checked);
    vm.setAutoPlayLesson(!autoPlayLessonEnabled);
    localStorage.setItem(
      'course-preferences',
      JSON.stringify({ autoPlay: !autoPlayLessonEnabled }),
    );

    vm.handleAutoplayChanged(autoPlayLessonEnabled);
  };

  return (
    <SwitchContainer>
      <SwitchInput
        id="checkbox"
        role="checkbox"
        checked={isChecked}
        type="checkbox"
        onChange={handleChange}
        aria-checked={isChecked}
        tabIndex={0}
        aria-describedby="Autoplay videos"
      />

      <SwitchSlider htmlFor="checkbox">
        <span className={isChecked ? 'on' : 'off'}>{isChecked ? <VerticalLine /> : <Dot />}</span>
      </SwitchSlider>
    </SwitchContainer>
  );
};
